// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.header {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding: 0 50px;
  width: 100%;
  height: 80px;
}
.header .icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 15px;
  margin-right: 10px;
}
.header .header-left-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.header .header-left-container .header-left {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.header .header-left-container .header-left h5 {
  color: #0669B3;
  margin: 0;
  font-weight: 600;
}
.header .header-left-container .header-left h6 {
  color: #577d00;
  font-weight: 600;
}
.header .header-left-container .header-right {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}
.header .header-left-container .header-right .emp-info-container {
  display: flex;
  flex-direction: column;
  align-items: self-end;
}
.header .header-left-container .header-right .emp-info-container .emp-first-last {
  color: #0669B3;
  font-weight: 700;
  font-size: 0.9em;
}
.header .header-left-container .header-right .emp-info-container .emp-position {
  color: #636161;
  font-size: 0.9em;
}
.header .header-left-container .header-right .emp-info-container .emp-location {
  padding-top: 10px;
  font-size: 0.9em;
  text-decoration: none;
}
.header .header-left-container .header-right .emp-icon {
  padding: 0 20px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/AdminHeader.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAUJ;AARI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;AAUR;AARI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AAUR;AARQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAUZ;AATY;EACI,cDGH;ECFG,SAAA;EACA,gBAAA;AAWhB;AATY;EACI,cDrBE;ECsBF,gBAAA;AAWhB;AARQ;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;AAUZ;AARY;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;AAUhB;AATgB;EACI,cDhBP;ECiBO,gBAAA;EACA,gBAAA;AAWpB;AATgB;EACI,cDzBZ;EC0BY,gBAAA;AAWpB;AATgB;EACI,iBAAA;EACA,gBAAA;EACA,qBAAA;AAWpB;AARY;EACI,eAAA;AAUhB","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 10px;\n    padding: 0 50px;\n    width: 100%;\n    height: 80px;\n\n    .icon-container {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 15px;\n        margin-right: 10px;\n    }\n    .header-left-container {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        \n        .header-left {\n            display: flex;\n            flex-direction: column;\n            justify-content: center;\n            h5 {\n                color: $pearl-blue;\n                margin: 0;\n                font-weight: 600;\n            }\n            h6 {\n                color: $DCSD-logo-green;\n                font-weight: 600;\n            }\n        }\n        .header-right {\n            display: flex;\n            align-items: center;\n            flex-direction: row-reverse;\n    \n            .emp-info-container {\n                display: flex;\n                flex-direction: column;\n                align-items: self-end;\n                .emp-first-last {\n                    color: $pearl-blue;\n                    font-weight: 700;\n                    font-size: .9em;\n                }\n                .emp-position {\n                    color: $grey4;\n                    font-size: .90em;\n                }\n                .emp-location {\n                    padding-top: 10px;\n                    font-size: .9em;\n                    text-decoration: none;\n                }\n            }\n            .emp-icon {\n                padding: 0 20px;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
